import { formatCHF } from "./format";

export function creditOnlyRefund(order) {
  const cash = order.final_price ?? order.price ?? 0;
  return Number(cash) === 0 && ["delivery_pack", "subscription_full_credit", "wallet_credit_full"].includes(order.payment_source);
}

export function cancellationSuccessMessage(order) {
  if (order.refund_review_required) return "Ordine annullato. Credito e rimborso richiedono verifica dell’assistenza.";
  if (order.payment_source === "delivery_pack") {
    return order.refund_status === "succeeded" && order.pack_credit_restored_at
      ? "Ordine annullato. 1 corsa riaccreditata al pacchetto."
      : "Ordine annullato. Riaccredito della corsa da completare.";
  }
  if (order.payment_source === "subscription_full_credit") {
    return order.inclusion_restored_at
      ? "Ordine annullato. 1 corsa riaccreditata sul tuo piano."
      : "Ordine annullato. Riaccredito della corsa da completare.";
  }
  if (order.wallet_credit_restored_at) {
    return `Ordine annullato. ${formatCHF(order.wallet_credit_restored_chf || 0)} riaccreditati nel wallet.` +
      (order.refund_status === "pending" ? " Rimborso monetario ancora da completare." : "");
  }
  return order.refund_status === "pending"
    ? "Ordine annullato. Richiesta di rimborso registrata."
    : "Ordine annullato.";
}

export function refundPresentation(order) {
  if (order.refund_review_required) return {
    title: "Credito e rimborso da verificare",
    message: "La spedizione è annullata. L’assistenza deve verificare credito, inclusione e possibile penale; nessun riaccredito è ancora confermato.",
  };
  if (creditOnlyRefund(order)) {
    const done = order.refund_status === "succeeded";
    const wallet = order.payment_source === "wallet_credit_full";
    return {
      title: done ? (wallet ? "Credito wallet riaccreditato" : "Corsa riaccreditata") : "Riaccredito in attesa",
      message: done
        ? (wallet ? `${formatCHF(order.wallet_credit_restored_chf || 0)} sono tornati nel wallet DapNow.` : "La corsa è stata restituita al pacchetto o piano utilizzato. Nessun rimborso monetario per questa spedizione.")
        : "La spedizione è annullata. Il riaccredito deve ancora essere completato; nessun rimborso monetario è stato eseguito.",
    };
  }
  const amount = formatCHF(order.refund_amount ?? order.cancellation_policy?.refund_chf ?? 0);
  return order.refund_status === "succeeded"
    ? { title: "Rimborso elaborato", message: `Rimborso di ${amount} elaborato. I tempi di accredito dipendono dal metodo di pagamento.` }
    : { title: "Rimborso da completare", message: `Richiesta di rimborso di ${amount} registrata. L’esito sarà confermato dopo l’elaborazione.` };
}
